import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import React from 'react';

const AbroadGraphUsageSkeleton = () => {
  return (
    <div className='abroad-graph-usage-skeleton'>
      <div className='title-skeleton'>
        <Skeleton />
      </div>
      <div className='circle-graph-skeleton-wrapper'>
        <div className='circle-graph-upper-line-skeleton'>
          <Skeleton />
        </div>
        <div className='circle-graph-skeleton'>
          <Skeleton circle width={132} height={132} />
        </div>
      </div>
      <div className='progress-bar-skeleton-wrapper'>
        <div className='circle-graph-upper-line-skeleton'>
          <Skeleton />
        </div>
        <div className='progress-bar-skeleton'>
          <Skeleton />
        </div>
      </div>

      <div className='see-all-usages-line'>
        <Skeleton />
      </div>
    </div>
  );
};

export default AbroadGraphUsageSkeleton;
